import type { FaqItem, LevelPack, MapFeature, MethodStep, PainPoint, ProgressionStage, SamplePage, Stat, Testimonial } from '../types/landing';
export const stats: Stat[] = [{
  value: '+300',
  label: 'Mapas mentales'
}, {
  value: '+1.200',
  label: 'Kits vendidos'
}, {
  value: '+200',
  label: 'Ejercicios prácticos'
}, {
  value: '98%',
  label: 'Lo recomiendan'
}];
export const beforeList: string[] = ["Pasar horas buscando explicaciones diferentes para entender un mismo tema.", 'Estudiar reglas gramaticales y olvidarlas pocos días después.', 'Tener vocabulario, gramática y expresiones repartidos entre videos, apuntes, aplicaciones y páginas web.', 'No saber qué tema estudiar primero ni qué deberías aprender después.', 'Sentir que entiendes inglés cuando lo lees, pero bloquearte cuando necesitas utilizarlo.', 'Llegar a un nivel intermedio y sentir que estás aprendiendo siempre lo mismo.'];
export const afterList: string[] = ['Abre el mapa del tema que quieres estudiar y encuentra lo esencial organizado en una sola vista.', 'Relaciona vocabulario, estructuras, ejemplos y frases útiles visualmente.', 'Sigue una progresión organizada desde A1 hasta C2.', 'Repasa rápidamente un tema antes de un examen, una clase, un viaje o una conversación.', 'Identifica errores frecuentes y aprende cómo utilizar correctamente cada estructura.', 'Pasa de conceptos básicos de supervivencia y vida cotidiana a inglés avanzado, formal y preciso.'];
export const painPoints: PainPoint[] = [{
  icon: '😵',
  title: 'Estudias pero olvidas',
  body: 'Lees una explicación, parece que la entendiste y unos días después ya no recuerdas cómo utilizarla.'
}, {
  icon: '⏱️',
  title: 'Pierdes demasiado tiempo buscando',
  body: 'YouTube, TikTok, Google, apuntes, cursos… Tienes mucha información, pero nada organizado.'
}, {
  icon: '🤷',
  title: 'No sabes por dónde continuar',
  body: 'Estudias inglés, pero no tienes una ruta clara que te diga qué conceptos corresponden a tu nivel.'
}, {
  icon: '📚',
  title: 'La gramática tradicional te resulta pesada',
  body: 'Páginas enteras de teoría hacen que algo sencillo termine pareciendo mucho más complicado.'
}, {
  icon: '🧠',
  title: 'Necesitas verlo para entenderlo',
  body: 'Aprendes mejor cuando puedes relacionar conceptos, ejemplos, colores, estructuras y palabras de manera visual.'
}, {
  icon: '🚧',
  title: 'Sientes que estás estancado',
  body: 'Ya conoces bastante inglés, pero necesitas vocabulario, conectores, estructuras y formas de expresarte que te permitan avanzar.'
}];
export const levelPacks: LevelPack[] = [{
  code: 'A1',
  badge: '📘',
  title: 'Construye tus primeras bases en inglés',
  intro: 'Empieza desde cero con los conceptos fundamentales que necesitas para comenzar a comunicarte.',
  topics: 'Saludos, presentaciones, números, fechas, familia, vocabulario cotidiano, estructuras básicas, preguntas frecuentes y mucho más.',
  closing: 'Ideal si estás comenzando o quieres reconstruir tus bases correctamente.',
  accent: '#2C6FB5'
}, {
  code: 'A2',
  badge: '📗',
  title: 'Empieza a desenvolverte en situaciones reales',
  intro: 'Avanza hacia tiempos verbales, comparaciones, planes, experiencias y situaciones cotidianas.',
  topics: 'Viajes, compras, salud, transporte, trabajo, redes sociales, vacaciones, planes y conversaciones del día a día.',
  closing: 'Pasa de conocer palabras sueltas a construir ideas completas.',
  accent: '#5C9E3F'
}, {
  code: 'B1',
  badge: '📙',
  title: 'Gana independencia al comunicarte',
  intro: 'Amplía tu vocabulario y aprende a mantener conversaciones más naturales.',
  topics: 'Trabajo, educación, tecnología, cultura, medio ambiente, viajes, opiniones, comunicación y situaciones reales.',
  closing: 'Empieza a dejar atrás el inglés básico y expresa mejor lo que piensas.',
  accent: '#D98324'
}, {
  code: 'B2',
  badge: '📕',
  title: 'Habla y escribe con mayor precisión',
  intro: 'Aprende estructuras más avanzadas, conectores, diferencias de registro y errores frecuentes.',
  topics: 'Inglés formal e informal, argumentación, condicionales, verb patterns, conectores avanzados y expresiones más naturales.',
  closing: 'Construye un inglés mucho más sólido, preciso y adaptable a cada situación.',
  accent: '#C93E2C'
}, {
  code: 'C1',
  badge: '📓',
  title: 'Lleva tu inglés a un nivel avanzado',
  intro: 'Trabaja matices, vocabulario avanzado, argumentación, registros, estructuras complejas y comunicación profesional.',
  topics: 'Registros formales, discurso académico, matices de significado y comunicación profesional.',
  closing: 'Deja de limitarte a “hablar correctamente” y empieza a expresarte con profundidad.',
  accent: '#6B4E9B'
}, {
  code: 'C2',
  badge: '📔',
  title: 'Domina los matices del idioma',
  intro: 'El nivel final del sistema está enfocado en precisión, registro, análisis y dominio avanzado del inglés.',
  topics: 'Idioms, connotación, estilo, recursos retóricos y análisis fino del idioma.',
  closing: 'Para quienes quieren comprender y utilizar el idioma con un nivel mucho más cercano al dominio completo.',
  accent: '#2F7A62'
}];
export const mapFeatures: MapFeature[] = [{
  icon: '🧠',
  title: 'Organización visual',
  body: 'Los conceptos importantes aparecen separados y relacionados de forma clara.'
}, {
  icon: "🌍",
  title: 'Inglés + Español',
  body: 'Explicaciones y referencias que ayudan a comprender rápidamente el significado.'
}, {
  icon: '💬',
  title: 'Ejemplos reales',
  body: 'No solo ves una regla: ves cómo puede utilizarse.'
}, {
  icon: '🗣️',
  title: 'Frases útiles',
  body: 'Expresiones que puedes llevar directamente a conversaciones reales.'
}, {
  icon: '📚',
  title: 'Vocabulario',
  body: 'Palabras organizadas según situaciones y temáticas.'
}, {
  icon: '⚡',
  title: 'Tips rápidos',
  body: 'Recordatorios para comprender o utilizar mejor cada concepto.'
}];
export const progressionStages: ProgressionStage[] = [{
  range: 'A1 – A2',
  theme: 'Supervivencia + vida cotidiana',
  body: 'Aprende a desenvolverte y construir una base sólida.'
}, {
  range: 'B1 – B2',
  theme: 'Independencia + precisión',
  body: 'Aprende a desarrollar ideas, mantener conversaciones y expresarte mejor.'
}, {
  range: 'C1 – C2',
  theme: 'Matiz + registro + dominio avanzado',
  body: 'Aprende a adaptar el idioma a contextos más complejos, académicos y profesionales.'
}];
export const methodSteps: MethodStep[] = [{
  step: '1',
  title: 'Aprende',
  body: 'Mira el mapa mental correspondiente.'
}, {
  step: '2',
  title: 'Practica',
  body: 'Resuelve los ejercicios sin mirar las respuestas.'
}, {
  step: '3',
  title: 'Comprueba',
  body: 'Corrige utilizando el Answer Key.'
}, {
  step: '4',
  title: 'Revisa',
  body: 'Si cometiste errores, vuelve al mapa mental.'
}, {
  step: '5',
  title: 'Avanza',
  body: 'Continúa con el siguiente tema.'
}];
export const exerciseTypes: string[] = ['Completar oraciones', 'Elegir la opción correcta', 'Relacionar conceptos', 'Corregir errores', 'Construir frases', 'Crear mini diálogos', 'Responder preguntas', 'Practicar vocabulario', 'Utilizar estructuras gramaticales', 'Resolver situaciones cotidianas'];
export const samplePages: SamplePage[] = [{
  level: 'Ejemplo A1',
  title: 'Saludos y Presentaciones',
  body: 'Aprende las primeras expresiones necesarias para presentarte y comenzar una conversación.',
  image: 'https://cdn.magicpatterns.com/uploads/oSLi5Mk3sJrwCravQodBEP/image.png'
}, {
  level: 'Ejemplo A2',
  title: 'Present Perfect: Introducción',
  body: 'Cuándo se usa, cómo se forma con have/has, las palabras clave (just, already, yet), un mini diálogo y los errores más frecuentes.',
  image: 'https://cdn.magicpatterns.com/uploads/6i4KMXkpL3yMPMwnx45Gzw/WhatsApp_Image_2026-09-12_at_12.11.29.jpg'
}, {
  level: 'Ejemplo B1',
  title: 'Gerundios e Infinitivos',
  body: 'Qué verbos van con -ing y cuáles con to + infinitivo, listas de verbos frecuentes, ejemplos y los errores más comunes.',
  image: 'https://cdn.magicpatterns.com/uploads/1UFmHmZ1ureRzzLPCGseQ4/image.png'
}, {
  level: 'Ejemplo B2',
  title: 'Frases Escindidas (Cleft Sentences)',
  body: 'Cómo dar énfasis con “It was… that…”, “What… is…” o “The reason why…”, con estructuras, ejemplos reales y errores comunes.',
  image: 'https://cdn.magicpatterns.com/uploads/xAvA1wBmLmo1whcP6PhCKf/image.png'
}, {
  level: 'Ejemplo C1',
  title: 'Cohesión Textual Avanzada',
  body: 'Conectores de secuencia, referencia y sustitución, linking devices sofisticados y los errores que rompen la cohesión de un texto.',
  image: 'https://cdn.magicpatterns.com/uploads/kj9eu7kbGpYmfKNd3uTHkh/image.png'
}, {
  level: 'Ejemplo C2',
  title: 'Estructuras Avanzadas para Mayor Impacto',
  body: 'Inversión, oraciones enfáticas, anteposición, pasivas avanzadas y recursos retóricos para dar fuerza y precisión a tu mensaje.',
  image: 'https://cdn.magicpatterns.com/uploads/gfwow5bt2qPNdzwFscfvRo/image.png'
}];
export const testimonials: Testimonial[] = [{
  quote: 'Lo que más me gusta es poder ir directamente al tema que necesito. Si tengo una duda con un tiempo verbal, abro el mapa y tengo todo resumido.',
  name: "Lucas M. - GBA, ARG"
}, {
  quote: 'Había estudiado inglés varias veces pero siempre terminaba dejando. Ver claramente qué corresponde a cada nivel me ayudó a estudiar con mucho más orden.',
  name: "Camila R. - Mendoza, ARG"
}, {
  quote: 'Gracias, me está ayudando mucho a cursar Inglés 3 de mi Facultad, siempre me fue más fácil estudiar visualmente.',
  name: "Rosana S. - Jujuy, ARG"
}];
export const faqItems: FaqItem[] = [{
  question: '¿Cómo recibo el material?',
  answer: ['Después de completar tu compra recibirás acceso al contenido digital para comenzar a utilizarlo.']
}, {
  question: '¿Incluye ejercicios?',
  answer: ['Sí. El sistema se complementa con el English Practice Master Kit™, creado para transformar los conceptos de los mapas en práctica.']
}, {
  question: '¿Hay pagos mensuales?',
  answer: ['No, el pago es único y sin suscripción.']
}];